import { MenuItem, menuItemClasses, styled } from "@mui/material";

const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  [`&.${menuItemClasses.selected}`]: {
    background: `${theme.palette.accentInfo20.main}80`,
    fontWeight: "bold",
    width: "100%",
  },
}));

export { MenuItemStyled };
